import { render } from "./GlobalErrorModal.vue?vue&type=template&id=470c4df7"
import script from "./GlobalErrorModal.vue?vue&type=script&lang=js"
export * from "./GlobalErrorModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__